/**
 * Class description
 *
 * Created: 2017-10-09
 * @author jonas
 */
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";

export class TeslaReelView extends PIXI.Container {
    get bottomLayer():PIXI.Container {
        return this._bottomLayer;
    }

    private _reelId:number;
    private _bottomLayer:PIXI.Container;

    constructor(reelId:number) {
        super();
        this._reelId = reelId;

        this._bottomLayer = new PIXI.Container();
        this._bottomLayer.name = "TeslaReelView.bottomLayer";

        const position = GameConfig.instance.REEL_DISPLAY_POSITIONS[this._reelId];
        this._bottomLayer.position.set(position[0], position[1]);
        this.position.set(position[0], position[1]);

        this.name = "TeslaReelView";

    }

    public addChildToBottom(child:PIXI.DisplayObject) {
        return this._bottomLayer.addChild(child);
    }

    public addChildToTop(child:PIXI.DisplayObject) {
        return super.addChild(child);
    }

    public addChild<T extends PIXI.DisplayObject>(...children:T[]):T {
        return this._bottomLayer.addChild(children[0]);
    }
}